import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccountProfileTabsComponent } from './account-profile-tabs.component';

const routes: Routes = [
  {
    path: '',
    component: AccountProfileTabsComponent,
    data: {
      title: ['sidebar_user_profile'],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountProfileRoutingModule {}
